import React, { useContext } from 'react';

import { DragSource } from 'react-dnd';

import { removeFormat } from '@spark-labs/avocado-ui/dist/utils/content';
import { BareContentTemplateLegacy } from '@go-shared/types/contentTemplate';
import { truncateWords } from '@go-shared/lib/string';
import { collectSource, contentDragSource } from '@go-client/lib/feedEditor';
import { BubbleBadge } from './BubbleUI';
import { hashStringToColor } from '@go-shared/lib/utils';
import { FeedEditorCtx } from '@go-client/context/FeedEdtitorContext';

/**
 * DnD setup
 */
export const CONTENT_DND_TYPE = 'content';
export const MAX_EXCERPT_LENGTH = 80;

interface DraggableContentItemProps {
  connectDragSource?: any;
  isDragging?: boolean;
  borderColor?: 'lime' | 'ocean';
  contentTemplate: BareContentTemplateLegacy;
  onDragStart?: () => void;
  onDoubleClick?: () => void;
  tags?: string[];
}

export interface DraggedContentItem {
  contentTemplate: BareContentTemplateLegacy;
}

function DraggableContentItem(props: DraggableContentItemProps) {
  const context = useContext(FeedEditorCtx);

  let { _id, content, name } = props.contentTemplate;
  let contentExcerpt = truncateWords(removeFormat(content, ' '), MAX_EXCERPT_LENGTH);
  let bgColor = props.isDragging ? 'bg-blue-light' : 'bg-white';
  let borderColor = `border-${props.borderColor} border-l-8` || '';
  let ctMatch = context.contentTemplates.find(ct => ct._id === _id);
  let etMatch = context.eventTemplates.find(et => et._id === _id);

  return props.connectDragSource(
    <div
      className={`FeedDraggableContentItem p-2 cursor-move shadow rounded-sm ${bgColor} ${borderColor}`}
      onDoubleClick={props.onDoubleClick}
    >
      <div className="flex items-start">
        <h1 className="text-sm uppercase font-semibold">{name}</h1>
        {ctMatch && (
          <BubbleBadge
            className="ml-auto -mt-2 -mr-2 flex-shrink-0"
            style={{ borderTopRightRadius: 0, borderTopLeftRadius: 0, borderBottomRightRadius: 0 }}
            color={hashStringToColor(ctMatch.type || 'basic')}
          >
            {ctMatch.type || 'basic'}
          </BubbleBadge>
        )}
        {etMatch && etMatch.segment && (
          <BubbleBadge
            className="ml-auto -mt-2 -mr-2 flex-shrink-0"
            style={{ borderTopRightRadius: 0, borderTopLeftRadius: 0, borderBottomRightRadius: 0 }}
            color={etMatch.segment.color}
          >
            {etMatch.segment.name}
          </BubbleBadge>
        )}
      </div>
      <div className="text-xs" dangerouslySetInnerHTML={{ __html: contentExcerpt }}></div>
      <div className="text-xs">
        {(props.tags || []).map(t => (
          <BubbleBadge key={t} className="py-1-i mr-1 mt-1" color={hashStringToColor(t)}>
            {t}
          </BubbleBadge>
        ))}
      </div>
    </div>
  );
}

export default DragSource(
  CONTENT_DND_TYPE,
  contentDragSource<DraggableContentItemProps>(),
  collectSource
)(DraggableContentItem);
